// extracted by mini-css-extract-plugin
export var container = "styles-module--container--eqKkk";
export var videoContainer = "styles-module--videoContainer--FGjF8";
export var title = "styles-module--title--HJqyG";
export var imgWave = "styles-module--imgWave--FI4oz";
export var imgAppStore = "styles-module--imgAppStore--jW-Dq";
export var buttonWrapper = "styles-module--buttonWrapper--ojN25";